import { render, staticRenderFns } from "./BlocMainTitle.vue?vue&type=template&id=6869d31c&scoped=true"
import script from "./BlocMainTitle.vue?vue&type=script&lang=js"
export * from "./BlocMainTitle.vue?vue&type=script&lang=js"
import style0 from "./BlocMainTitle.vue?vue&type=style&index=0&id=6869d31c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6869d31c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VToolbarTitle})
